




































































































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  OnlineBookingConfigWithDiscipline,
  ResourceOnlineBookingConfig,
  ResourceOnlineBookingConfigErrorsObject,
} from '@centers/interfaces/online-booking-config';
import { resourceOnlineBookingConfigFields } from '@/config/online-booking-config';
import BpcFormProvider from '@shared/components/forms/form-provider.vue';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import BpcMultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import BpcDatepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import BpcInputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import BpcTextarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import BpcSwitch from '@shared/components/forms/inputs/switch/switch.vue';
import BpcEntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { Subscription } from 'rxjs';
import BpcSwitchWithDescription from '@shared/components/forms/inputs/switch-with-description.vue';
import BpcSection from '@shared/components/forms/inputs/section/section.vue';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-resource-online-booking-config-form',
  components: {
    BpcFormProvider,
    BpcInput,
    BpcMultiSelect,
    BpcDatepicker,
    BpcInputGroup,
    BpcTextarea,
    BpcSwitch,
    BpcEntitySelect,
    BpcSwitchWithDescription,
    BpcSection,
  },
})
export default class ResourceOnlineBookingConfigForm extends Vue {
  @Prop(Object) readonly value: ResourceOnlineBookingConfig;
  @Prop(Array) readonly disciplinesForOnlineBookingIds: number[];

  loading = false;
  loadingDisciplineOnlineBookingConfig = false;
  disciplineOnlineBookingConfigSubscription: Subscription = null;
  errorsObject: ResourceOnlineBookingConfigErrorsObject = {};
  disciplineOnlineBookingConfigCollection: OnlineBookingConfigWithDiscipline[] = [];

  get formModel() {
    return this.value;
  }

  set formModel(value: ResourceOnlineBookingConfig) {
    this.$emit('input', value);
  }

  get noLabel() {
    return {
      labelAttributes: {
        for: 'no_label',
      },
    };
  }

  get disciplinesChangeDetectorStr() {
    return this.disciplinesForOnlineBookingIds.join(',');
  }

  get fieldsConfig() {
    return resourceOnlineBookingConfigFields;
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }

  get allowedDurationsDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    return this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: this.optionValuesToLabel(
        item.online_booking_config.allowed_durations,
        this.fieldsConfig.allowed_durations.options,
      ).join(', '),
      id: item.discipline_id,
    }));
  }

  get startTimeDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    return this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.start_time,
      id: item.discipline_id,
    }));
  }
  get stepDurationDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    return this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: this.optionValueToLabel(
        item.online_booking_config.step_duration,
        this.fieldsConfig.step_duration.options,
      ),
      id: item.discipline_id,
    }));
  }

  get maxTimeBeforeBookingDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    return this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.max_time_before_booking,
      id: item.discipline_id,
    }));
  }
  get minTimeBeforeBookingDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    return this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.min_time_before_booking,
      id: item.discipline_id,
    }));
  }
  get allowCancelBookingEventDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    return this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.allow_cancel_booking_event
        ? this.$t('global.yes')
        : this.$t('global.no'),
      id: item.discipline_id,
    }));
  }
  get minTimeBeforeCancellationDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    return this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.min_time_before_cancellation,
      id: item.discipline_id,
    }));
  }

  get minTimeBeforePlayerSlotCancellationDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    return this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.min_time_before_player_slot_cancellation,
      id: item.discipline_id,
    }));
  }
  get membershipRequiredDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    return this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: item.online_booking_config.membership_required
        ? this.$t('global.yes')
        : this.$t('global.no'),
      id: item.discipline_id,
    }));
  }

  get membershipsAllowBookingDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    return this.disciplineOnlineBookingConfigCollection.map(item => {
      const description = (item.online_booking_config?.memberships_allow_booking || []).length
        ? item.online_booking_config.memberships_allow_booking.join(', ')
        : this.$t('global.none');
      return {
        name: item.discipline_name,
        description: description,
        id: item.discipline_id,
      };
    });
  }

  get onlyWithSubscriptionsDescriptionItems() {
    if (!this.disciplineOnlineBookingConfigCollection) {
      return [];
    }
    return this.disciplineOnlineBookingConfigCollection.map(item => ({
      name: item.discipline_name,
      description: this.optionValueToLabel(
        item.online_booking_config.only_with_subscriptions,
        this.fieldsConfig.only_with_subscriptions.options,
      ),
      id: item.discipline_id,
    }));
  }

  get usingOnlineBookingV2() {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ONLINE_BOOKING_V2_MODULE_NAME);
  }

  mounted() {
    if ((this.disciplinesForOnlineBookingIds || []).length > 0) {
      this.loadDisciplineOnlineBookingConfig();
    }
  }

  resetFormModel() {
    this.formModel = {
      allowed_durations: [60],
      max_time_before_booking: '14',
      min_time_before_booking: '0',
      allow_cancel_booking_event: false,
      min_time_before_cancellation: '24',
      min_time_before_player_slot_cancellation: '48',
      membership_required: false,
      memberships_allow_booking: [],
      step_duration: 60,
      start_time: '08:00',
      only_with_subscriptions: 'subscription_only',
      defaultValueSwitchModel: {
        allowed_durations: false,
        max_time_before_booking: false,
        min_time_before_booking: false,
        allow_cancel_booking_event: false,
        min_time_before_cancellation: false,
        min_time_before_player_slot_cancellation: false,
        membership_required: false,
        memberships_allow_booking: false,
        step_duration: false,
        start_time: false,
        only_with_subscriptions: false,
      },
    };
  }

  manageSaveErrors(errors: any) {
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      this.$set(this.errorsObject, key, errors[key]);
    });
  }

  optionValueToLabel(value, options) {
    if (!value) {
      return '';
    }

    const option = options.find(option => option.value === value);
    return option ? this.$t(option.text) : value;
  }
  optionValuesToLabel(values, options) {
    if (!values) {
      return [];
    }
    return values.map(value => {
      const option = options.find(option => option.value === value);
      return option ? this.$t(option.text) : value;
    });
  }

  async loadDisciplineOnlineBookingConfig() {
    this.loadingDisciplineOnlineBookingConfig = true;
    const path = this.$bpcApiRouteHelper.getApiPath('disciplines/online-booking-config');
    const params = {
      discipline_ids: this.disciplinesForOnlineBookingIds,
    };
    if (this.disciplineOnlineBookingConfigSubscription) {
      this.disciplineOnlineBookingConfigSubscription.unsubscribe();
    }
    this.disciplineOnlineBookingConfigSubscription = this.$bpcApi.get(path, { params }).subscribe(
      (response: any) => {
        this.disciplineOnlineBookingConfigCollection = response.data;
        this.loadingDisciplineOnlineBookingConfig = false;
      },
      (error: any) => {
        this.loadingDisciplineOnlineBookingConfig = false;
        console.error(error);
      },
    );
  }

  async loadDisciplineOnlineBookingConfigIfStopChanging() {
    const changeDetectorStr = this.disciplinesChangeDetectorStr;
    setTimeout(() => {
      if (changeDetectorStr === this.disciplinesChangeDetectorStr) {
        this.loadDisciplineOnlineBookingConfig();
      }
    }, 300);
  }

  @Watch('disciplinesChangeDetectorStr')
  onDisciplinesChange() {
    this.loadDisciplineOnlineBookingConfigIfStopChanging();
  }

  @Watch('formModel', { deep: true })
  onFormModelChange() {
    this.$emit('formModelChange', this.formModel);
  }
}
